import { useMemo } from 'react';
import { publicTieredEditionActions, walletTieredEditionActions } from '@soundxyz/tiered-sdk-viem';
import { chainIds } from '@soundxyz/utils/const';
import { useStableCallback } from '@components-shared/src/hooks/useStableCallback';
import { useConnectedAuth } from '@context/auth/connected';
import { AVAILABLE_CHAIN_IDS } from '@utils/constants';

export function useTieredSdk() {
  const { getSigner, provider } = useConnectedAuth();

  const tieredProviderOptimism = useMemo(() => {
    return provider(AVAILABLE_CHAIN_IDS.optimism).extend(publicTieredEditionActions);
  }, [provider]);

  const tieredProviderMainnet = useMemo(() => {
    return provider(AVAILABLE_CHAIN_IDS.eth).extend(publicTieredEditionActions);
  }, [provider]);

  const tieredProvider = useStableCallback((chainId: number) => {
    switch (chainId) {
      case chainIds.GOERLI:
      case chainIds.MAINNET:
        return tieredProviderMainnet;
      case chainIds.OPTIMISM_GOERLI:
      case chainIds.OPTIMISM:
        return tieredProviderOptimism;
      default:
        throw new Error(`Invalid chainId ${chainId}`);
    }
  });

  const tieredSigner = useStableCallback(async (chainId: number) => {
    const walletClient = await getSigner(chainId);

    return walletClient.extend(walletTieredEditionActions);
  });

  return {
    tieredProvider,
    tieredSigner,
  };
}
